<template>
    <div>
        <v-app id="inspire">
            <v-app-bar
                v-if="!loading.data"
                app
                dense
                flat
                color="white">
                <v-spacer></v-spacer>
                <ToolbarMenuRight />
            </v-app-bar>
            <v-main>
            <v-container fill-height class="justify-center">
                <div>
                    <h1 class="text-center">Welcome Back, {{ loggedInUser.name }}</h1>
                    <h6 class="text-center text-h6 mb-10">Please Choose a Module from Below</h6>
                    <div class="d-flex flex-column justify-center align-center">
                        <v-progress-linear
                        indeterminate
                        v-if="loading.data"
                        size="64"
                        color="primary"
                        class="my-4">
                    </v-progress-linear>
                </div>
                <v-row>
                    <v-col cols="12" md="6" v-if="modules && modules.sales" @click="$router.push('/sales')">
                        <v-sheet rounded="lg" elevation="1" class="pa-4 d-flex" v-ripple>
                            <v-icon size="50" color="primary" class="me-4">mdi-order-bool-descending</v-icon>
                            <div>
                                <div class="text-h5">Sales and Distribution</div>
                                <div class="text-subtitle-1">Customers, Sales Agreements and Accounts Receivables</div>
                            </div>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6" v-if="modules && modules.warehouse" @click="$router.push('/warehouse-select')">
                        <v-sheet rounded="lg" elevation="1" class="pa-4 d-flex" v-ripple>
                            <v-icon size="50" color="primary" class="me-4">mdi-warehouse</v-icon>
                            <div>
                                <div class="text-h5">Inventory Management</div>
                                <div class="text-subtitle-1">Items, Stock Movement, Inventory Controll</div>
                            </div>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6" v-if="modules && modules.purchase" @click="$router.push('/purchase')">
                        <v-sheet rounded="lg" elevation="1" class="pa-4 d-flex" v-ripple>
                            <v-icon size="50" color="primary" class="me-4">mdi-card-text</v-icon>
                            <div>
                                <div class="text-h5">Purchasing and Ordering</div>
                                <div class="text-subtitle-1">Suppliers, Purchase Orders and Accounts Payables</div>
                            </div>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6" v-if="modules && modules.accounting" @click="$router.push('/accounting')">
                        <v-sheet rounded="lg" elevation="1" class="pa-4 d-flex" v-ripple>
                            <v-icon size="50" color="primary" class="me-4">mdi-bank</v-icon>
                            <div>
                                <div class="text-h5">Financial Accounting</div>
                                <div class="text-subtitle-1">General Ledger, Journal Vouchers and Financial Statements</div>
                            </div>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6" v-if="modules && modules.fleet" @click="$router.push('/fleet')">
                        <v-sheet rounded="lg" elevation="1" class="pa-4 d-flex" v-ripple>
                            <v-icon size="50" color="primary" class="me-4">mdi-truck-cargo-container</v-icon>
                            <div>
                                <div class="text-h5">Fleet Management</div>
                                <div class="text-subtitle-1">Fleet, Trips and Performance</div>
                            </div>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="6" v-if="modules && modules.administration" @click="$router.push('/administration')">
                        <v-sheet rounded="lg" elevation="1" class="pa-4 d-flex" v-ripple>
                            <v-icon size="50" color="primary" class="me-4">mdi-cog</v-icon>
                            <div>
                                <div class="text-h5">Administration</div>
                                <div class="text-subtitle-1">Manage Users and Permissions</div>
                            </div>
                        </v-sheet>
                    </v-col>
                </v-row>
                </div>
                <router-view></router-view>
            </v-container>
            </v-main>
            <RetryDialog
                @submit="onRetryDialogSubmit"
                ref="retryDialog"/>
            <AlertDialog 
                ref="alertDialog"/>
            <snackbar-alert></snackbar-alert>
        </v-app>
    </div>
</template>

<script>
import ToolbarMenuRight from '@/components/common/ToolbarMenuRight';
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog'
import { mapActions, mapState } from 'vuex';
import SnackbarAlert from '../components/common/SnackbarAlert.vue';
    export default {
        components: {
            RetryDialog,
            AlertDialog,
            ToolbarMenuRight,
                SnackbarAlert
        },
        props: {
        source: String,
        },
        data: () => ({
            drawer: null,
            loading: {
                data: false
            }
        }),
        computed: {
            ...mapState('authentication', ["modules", "loggedInUser"]),
            filteredModules() {
                return ""
            }
        },
        methods: {
            ...mapActions('authentication', ['fetchModules']),
            async createdDataFetch() {
                try {
                    this.loading.data = true;
                    await this.fetchModules();
                    this.loading.data = false;
                } catch(error) {
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.retryDialog.open({target:"createdDataFetch",message});
                }
            },
            onRetryDialogSubmit(params){
                if(params.target == "createdDataFetch") {
                    if(params.retry) this.createdDataFetch();
                }
            },
        },
        created(){
           this.createdDataFetch();
        }
    }
</script>